// extracted by mini-css-extract-plugin
module.exports = {"popularArticleContainer":"popular-solutions-listing-module--popularArticleContainer--2d3tS","popularArticle":"popular-solutions-listing-module--popularArticle--zGJ4E"};